<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="nft-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-diamond-stone</v-icon>
                  <h1 class="header-title">NFT Market</h1>
                </div>
                <p class="header-subtitle">
                  Discover and trade exclusive music NFTs, merchandise, and digital collectibles
                </p>

                <!-- Action Buttons -->
                <div class="header-actions">
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-refresh"
                    @click="refreshData()"
                    class="action-btn"
                  >
                    Refresh
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-tag-plus"
                    @click="sellOffer()"
                    class="action-btn create-offer-btn"
                  >
                    Create Offer
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Filters Section -->
              <div class="nft-section">
                <h2 class="section-title">
                  <v-icon left>mdi-format-list-bulleted</v-icon>
                  Offer Listing
                </h2>

                <!-- Search Field -->
                <v-text-field
                  v-model="searchQueryEvent"
                  placeholder="Search NFT offers..."
                  prepend-inner-icon="mdi-magnify"
                  density="comfortable"
                  hide-details
                  clearable
                  class="search-field mb-4"
                  variant="outlined"
                  disabled
                ></v-text-field>

                <!-- Category Filters -->
                <div class="category-filters">
                  <v-chip-group
                    v-model="filter"
                    multiple
                    column
                    @update:modelValue="handleFilterChange"
                    class="filter-chips"
                  >
                    <v-chip value="all" class="filter-chip filter-chip-all">
                      <v-icon left size="18">mdi-apps</v-icon>
                      All
                    </v-chip>
                    <v-chip value="nft_music" class="filter-chip filter-chip-music">
                      <v-icon left size="18">mdi-music-note</v-icon>
                      Music
                    </v-chip>
                    <v-chip value="nft_store" class="filter-chip filter-chip-store">
                      <v-icon left size="18">mdi-shopping</v-icon>
                      Merchandise
                    </v-chip>
                    <v-chip value="nft_bonus" class="filter-chip filter-chip-bonus">
                      <v-icon left size="18">mdi-gift</v-icon>
                      Bonus
                    </v-chip>
                    <v-chip value="nft_geo" class="filter-chip filter-chip-geo">
                      <v-icon left size="18">mdi-map-marker</v-icon>
                      Geo
                    </v-chip>
                    <v-chip value="nft_tickets" class="filter-chip filter-chip-tickets">
                      <v-icon left size="18">mdi-ticket</v-icon>
                      Tickets
                    </v-chip>
                  </v-chip-group>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Categories Sections -->
              
              <!-- Music NFTs -->
              <div class="category-section">
                <div class="category-header">
                  <v-icon class="category-icon music-icons">mdi-music-circle</v-icon>
                  <h3 class="category-title">Music NFTs</h3>
                  <v-chip size="small" class="category-count">0</v-chip>
                </div>
                <div class="category-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-music-note-off</v-icon>
                  </div>
                  <p class="empty-text">No music NFT offers available</p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.2;"></v-divider>

              <!-- Merchandise NFTs -->
              <div class="category-section">
                <div class="category-header">
                  <v-icon class="category-icon store-icon">mdi-shopping</v-icon>
                  <h3 class="category-title">Merchandise</h3>
                  <v-chip size="small" class="category-count">0</v-chip>
                </div>
                <div class="category-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-shopping-outline</v-icon>
                  </div>
                  <p class="empty-text">No merchandise offers available</p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.2;"></v-divider>

              <!-- Bonus NFTs -->
              <div class="category-section">
                <div class="category-header">
                  <v-icon class="category-icon bonus-icon">mdi-gift</v-icon>
                  <h3 class="category-title">Bonus Items</h3>
                  <v-chip size="small" class="category-count">0</v-chip>
                </div>
                <div class="category-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-gift-outline</v-icon>
                  </div>
                  <p class="empty-text">No bonus offers available</p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.2;"></v-divider>

              <!-- Geo NFTs -->
              <div class="category-section">
                <div class="category-header">
                  <v-icon class="category-icon geo-icon">mdi-map-marker-circle</v-icon>
                  <h3 class="category-title">Geo NFTs</h3>
                  <v-chip size="small" class="category-count">0</v-chip>
                </div>
                <div class="category-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-map-marker-off</v-icon>
                  </div>
                  <p class="empty-text">No geo NFT offers available</p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.2;"></v-divider>

              <!-- Tickets NFTs -->
              <div class="category-section">
                <div class="category-header">
                  <v-icon class="category-icon tickets-icon">mdi-ticket-confirmation</v-icon>
                  <h3 class="category-title">Event Tickets</h3>
                  <v-chip size="small" class="category-count">0</v-chip>
                </div>
                <div class="category-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-ticket-outline</v-icon>
                  </div>
                  <p class="empty-text">No ticket offers available</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'NFT',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    offers: [],
    searchQueryEvent: '',
    filter: ["all"],

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },

  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.$store.dispatch('getNFTOffers', { 
        uid: this.user.uid, 
        token: this.user.token, 
        search: this.searchQueryEvent, 
        type: this.filter
      }).then(response => {
        this.offers = this.$store.getters.getNFTOffers;  
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Error occurred. Please try again later.");
        }
      })

    }
  },
  methods: {
    handleFilterChange(newfilter) {
      if (newfilter[newfilter.length - 1] === 'all') {
        this.filter = ['all'];
      } else if (this.filter.length === 0) {
        this.filter = ['all'];
      } else if (this.filter.length > 1 && this.filter.includes('all')) {
        this.filter = this.filter.filter(f => f !== 'all');
      }
      
      // Refresh data with new filters
      this.refreshData();
    },
    refreshData() {
      this.$store.dispatch('getNFTOffers', { 
        uid: this.user.uid, 
        token: this.user.token, 
        search: this.searchQueryEvent, 
        type: this.filter
      }).then(response => {
        this.offers = this.$store.getters.getNFTOffers;
        this.notify('Data refreshed successfully!');
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Error occurred. Please try again later.");
        }
      })
    },
    sellOffer() {
      this.notify('Create offer feature coming soon!');
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* NFT Header */
.nft-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: #b16abf;
  filter: drop-shadow(0 0 8px rgba(177, 106, 191, 0.5));
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.create-offer-btn:hover {
  background: rgba(177, 106, 191, 0.2) !important;
  border-color: rgba(177, 106, 191, 0.6) !important;
}

/* Section */
.nft-section {
  margin-bottom: 32px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Search Field */
.search-field {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.search-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.search-field .v-field:hover:not(.v-field--disabled)) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.search-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.search-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

:deep(.search-field.v-field--disabled .v-field) {
  opacity: 0.5;
}

/* Category Filters */
.category-filters {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.category-filters:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.filter-chips {
  margin: 0 !important;
}

.filter-chip {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  transition: all 0.3s ease;
  padding: 8px 16px;
  height: 40px !important;
}

.filter-chip:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
  transform: translateY(-2px);
}

.filter-chip-all.v-chip--selected {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: white !important;
}

.filter-chip-music.v-chip--selected {
  background: rgba(177, 106, 191, 0.3) !important;
  border-color: rgba(177, 106, 191, 0.8) !important;
}

.filter-chip-store.v-chip--selected {
  background: rgba(33, 150, 243, 0.3) !important;
  border-color: rgba(33, 150, 243, 0.8) !important;
}

.filter-chip-bonus.v-chip--selected {
  background: rgba(255, 152, 0, 0.3) !important;
  border-color: rgba(255, 152, 0, 0.8) !important;
}

.filter-chip-geo.v-chip--selected {
  background: rgba(76, 175, 80, 0.3) !important;
  border-color: rgba(76, 175, 80, 0.8) !important;
}

.filter-chip-tickets.v-chip--selected {
  background: rgba(244, 67, 54, 0.3) !important;
  border-color: rgba(244, 67, 54, 0.8) !important;
}

/* Category Sections */
.category-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.category-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.category-icon {
  font-size: 32px !important;
}

.music-icons {
  color: #b16abf;
}

.store-icon {
  color: #2196F3;
}

.bonus-icon {
  color: #FF9800;
}

.geo-icon {
  color: #4CAF50;
}

.tickets-icon {
  color: #F44336;
}

.category-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.category-count {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
  background: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Empty States */
.category-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  padding: 32px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.category-empty-state:hover {
  border-color: rgba(255, 255, 255, 0.1);
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.6), rgba(18, 18, 18, 0.6));
}

.empty-icon-wrapper {
  margin-bottom: 12px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
}

.empty-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nft-section,
.category-section {
  animation: slideIn 0.4s ease forwards;
}

.category-section:nth-child(1) { animation-delay: 0s; }
.category-section:nth-child(2) { animation-delay: 0.05s; }
.category-section:nth-child(3) { animation-delay: 0.1s; }
.category-section:nth-child(4) { animation-delay: 0.15s; }
.category-section:nth-child(5) { animation-delay: 0.2s; }

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip-group) {
  gap: 8px;
}

:deep(.v-chip .v-icon) {
  margin-right: 4px !important;
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .category-title {
    font-size: 20px;
  }

  .filter-chip {
    font-size: 14px !important;
    padding: 6px 12px;
    height: 36px !important;
  }

  .header-actions {
    width: 100%;
  }

  .action-btn {
    flex: 1;
  }
}
</style>